
import { getVueComponent, hasVueComponent } from '.'

import {debug } from '/vodalys/.jslibs'
const log = debug('vue:vuePlaceholder')

// import template from './vvuejs.parcel.vuePlaceholder.html'

export default {
    data() {
        return {
            vueComponent: '',
        }
    },
    props: ['component', 'handler', 'events', 'data'],
    template: '<component :key="component && component[\'#id\']" :is="vueComponent" :component="component" :handler="handler" :data="data" v-on="$listeners" class="vueplaceholder"></component>',
    methods: {
        /* ca sert ca ?
        onEvent([eventName, event]) {
            this.$emit(eventName, event)
        }*/
    },
    watch: {
        component :
        {
            handler() {
                if (!this.component)
                {
                    log('no component')
                    this.vueComponent = 'vue-angular-place-holder'
                    return
                }
                if (typeof this.component['#type'] === 'string') {
                    this.vueComponent = getVueComponent(this.component['#type'])
                }
                else if (this.component['#type'] instanceof Array) {
                    const type = this.component['#type'].find(_type => hasVueComponent(_type))
                    this.vueComponent = getVueComponent(type)
                }
                if (!this.vueComponent)
                {
                    log('!vueComponent let go vue-angular-place-holder', this.component['#type'])
                    this.vueComponent = 'vue-angular-place-holder'
                    return
                }

                log('this.vueComponent', this.vueComponent.name, this.vueComponent, this.component['#type'])
            },
            immediate : true
        }
    },
}